import { Directive, HostBinding, Input, TemplateRef, input } from '@angular/core';
import { FormErrorsMap } from '../form-error/form-error.model';

export const BaseFormControlDirectiveInputs = [
  'help',
  'label',
  'hint',
  'hintTemplate',
  'labelTemplate',
  'extendedHelpTooltip',
  'styleClass',
  'name',
  'placeholder',
  'forceShowValidationErrors',
  'errorLabels',
  'readonly',
  'addAsteriskToFakeRequiredLabel',
  'helpTooltipPosition',
];

@Directive({
  selector: '[uiBaseFormControl]',
  standalone: true,
})
export class BaseFormControlDirective {
  @Input()
  help: string | null = null;

  @Input()
  label = '';

  @Input()
  hint: string | null = null;

  @Input()
  hintTemplate: TemplateRef<unknown> | null = null;

  @Input()
  labelTemplate: TemplateRef<unknown> | null = null;

  readonly extendedHelpTooltip = input(false);

  readonly styleClass = input('');

  readonly name = input(null);

  @Input()
  placeholder: string | undefined = undefined;

  readonly forceShowValidationErrors = input(false);

  readonly errorLabels = input<FormErrorsMap>({});

  readonly readonly = input(false);

  readonly addAsteriskToFakeRequiredLabel = input(false);

  readonly helpTooltipPosition = input<'right' | 'left' | 'top' | 'bottom'>('left');

  @HostBinding('class.force-show-validation-errors')
  get showValidationErrorsClass() {
    return this.forceShowValidationErrors();
  }
}
